import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { GlobalStyles } from './styles/GlobalStyles';
import Layout from './components/Layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import NewClient from './pages/NewClient';
import ClientProfile from './pages/ClientProfile';
import Receipts from './pages/Receipts';
import NewReceipt from './pages/NewReceipt';
import ReceiptDetail from './pages/ReceiptDetail';
import RegisterPayment from './pages/RegisterPayment';
import Alerts from './pages/Alerts';
import Reports from './pages/Reports';
import Settings from './pages/Settings';

// Componente interno que tiene acceso al contexto de tema
const AppContent = () => {
  const { theme } = useTheme();
  
  return (
    <StyledThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <Routes>
          {/* Ruta pública de login */}
          <Route path="/login" element={<Login />} />
          
          {/* Rutas protegidas */}
          <Route path="/*" element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/clientes" element={<Clients />} />
                  <Route path="/clientes/nuevo" element={<NewClient />} />
                  <Route path="/clientes/:id/editar" element={<NewClient />} />
                  <Route path="/clientes/:id" element={<ClientProfile />} />
                  <Route path="/recibos" element={<Receipts />} />
                  <Route path="/recibos/nuevo" element={<NewReceipt />} />
                  <Route path="/recibos/:id" element={<ReceiptDetail />} />
                  <Route path="/registrar-pago" element={<RegisterPayment />} />
                  <Route path="/alertas" element={<Alerts />} />
                  <Route path="/reportes" element={<Reports />} />
                  <Route path="/configuracion" element={<Settings />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </StyledThemeProvider>
  );
};

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
